import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Channel } from '@portals/api';
import { BaseComponent, DrawerService } from '@portals/core';
import { ChannelsState } from '@portals/store';

@Component({
	selector: 'portals-channel-detail-update-drawer',
	templateUrl: './channel-detail-update-drawer.component.html',
	styleUrls: ['./channel-detail-update-drawer.component.scss'],
})
export class ChannelDetailUpdateDrawerComponent extends BaseComponent implements OnInit {
	form!: FormGroup;
	formData = new FormData();

	constructor(public drawer: DrawerService<Record<string, unknown>>, private formBuilder: FormBuilder, private channel: ChannelsState) {
		super();
	}

	getImage(file: File) {
		if (file) {
			this.formData.delete('files.image');
			this.formData.append('files.image', file, file.name);
		}
	}

	ngOnInit(): void {
		// @ts-ignore
		const {
			id, //
			name,
			description,
			external_url,
			is_active,
		} = this.drawer.context as Channel;

		this.form = this.formBuilder.group({
			id: [id],
			name: [name],
			description: [description],
			external_url: [external_url],
			is_active: [is_active],
		});
	}

	onSubmit() {
		if (this.form.invalid) {
			return;
		}

		const channel = this.form.value as Channel;

		this.formData.append('data', JSON.stringify(this.form.value));

		this.subscribe(this.channel.update(channel.id, this.formData));
	}
}
